import React from 'react';

export const EditAccountNameSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2884_107259)">
      <path
        d="M1 13H13"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.5 7V9V9.5H4L9.5 4L7 1.5L1.5 7Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2884_107259">
        <rect width="14" height="14" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
